var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"participantId"},[_c('b-form',{on:{"submit":_vm.onSubmit}},[_c('b-form-group',[_c('b-form-input',{model:{value:(_vm.input),callback:function ($$v) {_vm.input=$$v},expression:"input"}})],1),_c('b-btn',{attrs:{"type":"submit"}},[_vm._v(_vm._s(_vm.$t('submit-button')))])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }